import {CUSTOM_ELEMENTS_SCHEMA, NgModule} from '@angular/core';
import {CommonModule, DecimalPipe} from '@angular/common';
import {CoreModule} from '../core/core.module';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {RouterModule} from '@angular/router';
import {GbAmtComponent} from './widgets/gb-amt/gb-amt.component';
import {GbGemeindeComponent} from './widgets/gb-gemeinde/gb-gemeinde.component';
import {GrundstueckNummerComponent} from './widgets/grundstueck-nummer/grundstueck-nummer.component';
import {RechteSelectionComponent} from './widgets/rechte-selection/rechte-selection.component';
import {HistoryOptionsComponent} from './widgets/history-options/history-options.component';
import {BelegComponent} from './widgets/beleg/beleg.component';
import {StichwortAblaufdatumComponent} from './widgets/stichwort-ablaufdatum/stichwort-ablaufdatum.component';
import {KompaktGrundstueckComponent} from './kompaktdarstellung/grundstueck/kompakt-grundstueck.component';
import {
  KompaktGrundbuchgeschaeftComponent
} from './kompaktdarstellung/grundbuchgeschaeft/kompakt-grundbuchgeschaeft.component';
import {KompaktTimepointComponent} from './kompaktdarstellung/timepoint/kompakt-timepoint.component';
import {KopfdatenelementComponent} from './widgets/kopfdatenelement/kopfdatenelement.component';
import {KompaktBelegComponent} from './kompaktdarstellung/beleg/kompakt-beleg.component';
import {LogoComponent} from './components/logo/logo.component';

import {HistoryDirective} from './directives/history.directive';
import {MetaDirective} from './directives/meta.directive';
import {MetaValidatorDirective} from './directives/meta-validator.directive';
import {MetaDisablerDirective} from './directives/meta-disabler.directive';
import {PermissionDirective} from './directives/permission.directive';
import {AsideToggleDirective} from './directives/aside.directive';
import {NAV_DROPDOWN_DIRECTIVES} from './directives/nav-dropdown.directive';
import {ComparatorService} from './services/comparator-service';
import {KompaktAmtnummerPipe} from './kompaktdarstellung/amt/kompakt-amtnummer-pipe';
import {ArtKurzPipe} from './pipes/simple/grundbuch-amt-kurz.pipe';
import {BelastungArtPipe} from './pipes/simple/belastung-art.pipe';
import {DatumPipe} from './pipes/simple/datum.pipe';
import {FormatBelegPipe} from './pipes/format/format-beleg.pipe';
import {GrundstueckArtPipe} from './pipes/simple/grundstueck-art.pipe';
import {FormatRechteIdPipe} from './pipes/format/format-rechte-id.pipe';
import {GbPersonPipe} from './pipes/simple/gb-person.pipe';
import {GrundstuecknummerPipe} from './pipes/simple/grundstuecknummer.pipe';
import {FormatTimepointPipe} from './pipes/format/format-timepoint.pipe';
import {OrderByTranslatePipe} from './pipes/order/order-by-translate.pipe';
import {OrderByGrundstuecknummerPipe} from './pipes/order/order-by-grundstuecknummer.pipe';
import {OrderByLastRechtGruppePipe} from './pipes/order/order-by-last-recht-gruppe.pipe';
import {OrderByGbGeschaeftPipe} from './pipes/order/order-by-gb-geschaeft.pipe';
import {OrderByGeoGeschaeftPipe} from './pipes/order/order-by-geo-geschaeft.pipe';
import {TranslateNamePipe} from './pipes/simple/translate-name.pipe';
import {YesNoPipe} from './pipes/simple/yes-no.pipe';
import {FormatGeschaeftsnummerPipe} from './pipes/format/format-geschaeftsnummer.pipe';
import {NamenInhaberPfandrechtartPipe} from './pipes/simple/namen-inhaber-pfandrechtart.pipe';
import {BetragPipe} from './pipes/simple/betrag.pipe';
import {
  KompaktPfandrechtBelastungComponent
} from './kompaktdarstellung/pfandrecht-belastung/kompakt-pfandrecht-belastung.component';
import {ComponentLocationStrategy} from './services/location-strategy/component-location-strategy';
import {DokulinkModalComponent} from '../dokulinkModal/dokulink-modal.component';
import {BreadcrumbComponent} from './breadcrumb/breadcrumb.component';
import {KompaktStammpersonComponent} from './kompaktdarstellung/stammperson/kompakt-stammperson.component';
import {DayMonthYearDatePipe} from './pipes/simple/dayMonthYearDate.pipe';
import {KompaktPersonenadresseComponent} from './kompaktdarstellung/personenadresse/kompakt-personenadresse.component';
import {GrundstueckSelectionComponent} from './widgets/grundstuecktype-selection/grundstuecktype-selection.component';
import {
  KompaktGrundstueckbeschreibungPipe
} from './kompaktdarstellung/grundstueck-beschreibung/kompakt-grundstueckbeschreibung.pipe';
import {ArrayAbbreviatePipe} from './pipes/simple/array-abbreviate.pipe';
import {FormatGebaeudeArtPipe} from './pipes/format/format-gebaeude-art.pipe';
import {OrtschaftSelectionComponent} from './widgets/ortschaft/ortschaft-selection.component';
import {KompaktGrundstueckPipe} from './kompaktdarstellung/grundstueck/kompakt-grundstueck.pipe';
import {TagebuchNummerComponent} from './widgets/tagebuch-nummer/tagebuch-nummer.component';
import {TeilDatumComponent} from './widgets/teil-datum/teil-datum.component';
import {DecimalHochkommaPipe} from './pipes/simple/decimalHochkomma.pipe';
import {PolGemeindeComponent} from './widgets/pol-gemeinde/pol-gemeinde.component';
import {
  KompaktGebaeudeeingangsadressePipe
} from './kompaktdarstellung/gebaeudeeingangsadresse/kompakt-gebaeudeeingangsadresse-pipe';
import {KompaktGebaeudePipe} from './kompaktdarstellung/gebaeude/kompakt-gebaeude-pipe';
import {GeometergeschaeftNummerComponent} from './widgets/geometergeschaeft-nummer/geometergeschaeft-nummer.component';
import {RechtsgueltigHaengigComponent} from './widgets/tagebuchstatus-selection/tagebuchstatus-selection.component';
import {AvMutationsNummerComponent} from './widgets/av-mutations-nummer/av-mutations-nummer.component';

import {FormatGeometergeschaeftsnummerPipe} from './pipes/format/format-geometergeschaeftsnummer.pipe';
import {KompaktAvMutationComponent} from './kompaktdarstellung/av-mutation/kompakt-av-mutation.component';
import {AutofocusDirective} from './directives/autofocus.directive';
import {KompaktPersongbComponent} from './kompaktdarstellung/persongb/kompakt-persongb.component';
import {HistorisiertComponent} from './kompaktdarstellung/historisiert/historisiert.component';
import {RechtsgrundComponent} from './kompaktdarstellung/rechtsgrund/rechtsgrund.component';
import {OrderByNameVornamePipe} from './pipes/order/order-by-name-vorname.pipe';
import {OrderByRechteIdPipe} from './pipes/order/order-by-rechte-id.pipe';
import {LinkComponent} from './components/link/link.component';
import {DokulinkComponent} from './components/dokulink/dokulink.component';
import {AuszugComponent} from './components/auszug/auszug.component';
import {CapSpinnerSmallComponent} from './components/cap-spinner-small/cap-spinner-small.component';
import {KompaktGrundbuchgeschaeftPipe} from './kompaktdarstellung/grundbuchgeschaeft/kompakt-grundbuchgeschaeft.pipe';
import {
  HaengigeGbGeschaefteComponent
} from './components/haengige/haengige-gb-geschaefte/haengige-gb-geschaefte.component';
import {
  HaengigeGeoGeschaefteComponent
} from './components/haengige/haengige-geo-geschaefte/haengige-geo-geschaefte.component';
import {HaengigeAuftraegeComponent} from './components/haengige/haengige-auftraege/haengige-auftraege.component';
import {OrderByAuftragPipe} from './pipes/order/order-by-auftrag.pipe';
import {AuszugPrintService} from './components/auszug/auszug-print-service';
import {EigentuemerAuszugSettingsComponent} from './components/auszug/settings/eigentuemer-auszug-settings.component';
import {GrundstueckAuszugSettingsComponent} from './components/auszug/settings/grundstueck-auszug-settings.component';
import {RechteAuszugSettingsComponent} from './components/auszug/settings/rechte-auszug-settings.component';
import {AuszugSettingsService} from './components/auszug/settings/auszug-settings-service';
import {RegionenComponent} from './widgets/regionen/regionen.component';
import {AuftragsNummerPipe} from './pipes/simple/auftragsNummer.pipe';
import {FormatUidPipe} from './pipes/format/format-uid.pipe';
import {DatumZeitPipe} from './pipes/simple/datumZeit.pipe';
import {ReadMoreComponent} from './widgets/read-more/read-more.component';
import {OrderByLastrechtEntryPipe} from './pipes/order/order-by-lastrecht-entry.pipe';
import {KompaktCapititelPipe} from './kompaktdarstellung/capititel/kompakt-capititel.pipe';
import {RubrikComponent} from './components/rubrik/rubrik.component';
import {KompaktStandardrechtComponent} from './kompaktdarstellung/standardrecht/kompakt-standardrecht.component';
import {KompaktGrundpfandrechtComponent} from './kompaktdarstellung/grundpfandrecht/kompakt-grundpfandrecht.component';
import {OrderByPfandrechtBelastungPipe} from './pipes/order/order-by-pfandrecht-belastung.pipe';
import {
  KompaktGrundstueckDetailComponent
} from './kompaktdarstellung/grundstueck/grundstueck-detail/kompakt-grundstueck-detail.component';
import {
  KompaktGrundstueckDetailPipe
} from './kompaktdarstellung/grundstueck/grundstueck-detail/kompakt-grundstueck-detail.pipe';
import {
  HaengigeGeschaefteAuftraegeComponent
} from './components/haengige/haengige-geschaefte/haengige-geschaefte-auftraege.component';
import {KompaktGebaeudeMasterPipe} from './kompaktdarstellung/gebaeude/kompakt-gebaeude-master-pipe';
import {
  KompaktAmtlicheBewertungComponent
} from './kompaktdarstellung/amtliche-bewertung/kompakt-amtliche-bewertung.component';
import {FormatAhvPipe} from './pipes/format/format-ahv.pipe';
import {
  KompaktStandardRechtBeschreibungComponent
} from './kompaktdarstellung/standardrecht-beschreibung/kompakt-standard-recht-beschreibung.component';
import {
  KompaktGrundpfandrechtBeschreibungComponent
} from './kompaktdarstellung/grundpfandrecht-beschreibung/kompakt-grundpfandrecht-beschreibung.component';
import {RechtListBeschreibungComponent} from './components/recht-list-beschreibung/recht-list-beschreibung.component';
import {OrderByGrundstuecknrRechtIdPipe} from './pipes/order/order-by-grundstuecknr-recht-id.pipe';
import {KompaktEigentumanteilPipe} from './kompaktdarstellung/eigentumanteil/kompakt-eigentumanteil.pipe';
import {GlaeubigerRolleCodePipe} from './pipes/simple/glaeubiger-rolle-code.pipe';
import {TagebuchValidatorDirective} from './directives/tagebuch-validator.directive';
import {EgridValidatorDirective} from './directives/egrid-validator.directive';
import {OrderByLastRechtRootEntryVmPipe} from './pipes/order/order-by-lastrechtrootentry.pipe';
import {OrderByLastRechtPersonEntryVmPipe} from './pipes/order/order-by-gb-lastrechtpersonentry.pipe';
import {FormatEdidPipe} from './pipes/format/format-edid.pipe';
import {
  KompaktVersionGebaeudeeingangsadressePipe
} from './kompaktdarstellung/gebaeudeeingangsadresse/kompakt-version-gebaeudeeingangsadresse-pipe';
import {FormatBeEdidPipe} from './pipes/format/format-be-edid.pipe';
import {OrderByEingangadressePipe} from './pipes/order/order-by-eingangadresse.pipe';
import {OrderByPfandrechtBelastungMasterPipe} from './pipes/order/order-by-pfandrechtBelastungMaster.pipe';
import {OrderByGlaeubigerSchuldnerMasterPipe} from './pipes/order/order-by-glaeubigerSchuldnerMaster.pipe';
import {
  KompaktGeometergeschaeftComponent
} from './kompaktdarstellung/geometergeschaeft/kompakt-geometergeschaeft.component';
import {KompaktBenutzerPipe} from './kompaktdarstellung/benutzer/kompakt-benutzer-pipe';
import {KompaktHandelsangabenPipe} from './kompaktdarstellung/handelsangaben/kompakt-handelsangaben.pipe';
import {GrundstueckflaecheComponent} from './widgets/grundstueck/table-grundstueckflaeche/grundstueckflaeche.component';
import {GebaeudeComponent} from './widgets/grundstueck/table-gebaeude/gebaeude.component';
import {StammgrundstueckComponent} from './widgets/grundstueck/table-stammgrundstueck/stammgrundstueck.component';
import {SonderrechtComponent} from './widgets/grundstueck/table-sonderrecht/sonderrecht.component';
import {
  DominierteGrundstueckeComponent
} from './widgets/grundstueck/table-dominierte-grundstuecke/dominierte-grundstuecke.component';
import {KuhrechtComponent} from './widgets/grundstueck/table-kuhrecht/kuhrecht.component';
import {AlpgrundstueckeComponent} from './widgets/grundstueck/table-alpgrundstuecke/alpgrundstuecke.component';
import {KompaktZusatzangabenComponent} from './kompaktdarstellung/zusatzangaben/kompakt-zusatzangaben.component';
import {FormatPersonstammAddressPipe} from './pipes/format/format-personstamm-address.pipe';
import {TooltipPersonstammPipe} from './pipes/simple/tooltip-personstamm.pipe';
import {ProjektstatusComponent} from './widgets/projektstatus/projektstatus.component';
import {StammpersonTableComponent} from './widgets/person/stammperson-table/stammperson-table.component';
import {
  GrundstueckBemerkungComponent
} from './widgets/grundstueck/grundstueck-bemerkung/grundstueck-bemerkung.component';
import {SubstringPipe} from './pipes/simple/substring.pipe';
import {BauortComponent} from './widgets/bauort/bauort.component';
import {GeogeschaeftTableComponent} from './widgets/geogeschaeft-table/geogeschaeft-table.component';
import {OrderByErstellzeitpunktPipe} from './pipes/order/order-by-erstellzeitpunkt.pipe';
import {BeschreibungTableWrapperComponent} from './components/table/beschreibung-table-wrapper.component';
import {ListLoaderWrapperComponent} from './components/list-loader-wrapper/list-loader-wrapper.component';
import {KompaktGwrGrundstueckPipe} from './kompaktdarstellung/gwr/kompakt-gwr-grundstueck.pipe';
import {GrundstueckTableComponent} from './widgets/grundstueck-table/grundstueck-table.component';
import {EigentumTableComponent} from './widgets/eigentum-table/eigentum-table.component';
import {StandardrechtTableComponent} from './widgets/standardrecht-table/standardrecht-table.component';
import {GrundpfandrechtTableComponent} from './widgets/grundpfandrecht-table/grundpfandrecht-table.component';
import {ContentHeaderComponent} from './components/content-header/content-header.component';
import {TitleFunctionbarComponent} from './components/title-functionbar/title-functionbar.component';
import {DirtyCheckModalComponent} from './components/modals/dirty-check-modal/dirty-check-modal.component';
import {DeleteCheckModalComponent} from './components/modals/delete-check-modal/delete-check-modal.component';
import {TitleComponent} from './components/title/title.component';
import {DokulinkItemBuilderFactory} from './components/dokulink/dokulinkItemBuilderFactory';
import {FormatAvReferenzNummerPipe} from './pipes/format/format-av-referenz-nummer.pipe';
import {ResetCheckModalComponent} from './components/modals/reset-check-modal/reset-check-modal.component';
import {SafeHtmlPipe} from './pipes/simple/safe-html-pipe.pipe';
import {SafeUrlPipe} from './pipes/simple/safe-url-pipe.pipe';
import {FormatAvReferenzNummernPipe} from './pipes/format/format-av-referenz-nummern.pipe';
import {MapsComponent} from './widgets/maps/maps.component';
import {MapServiceFactory} from './services/maps-service-factory';
import {FormatMapErrorPipe} from './pipes/format/format-map-error.pipe';
import {KompaktNeskoabGrundstueckComponent} from './kompaktdarstellung/neskoab/kompakt-neskoab-grundstueck.component';
import {NeskoabGrundstuecknummerPipe} from './kompaktdarstellung/neskoab/neskoab-grundstuecknummer.pipe';
import {SearchbarComponent} from '../layouts/intercapi-public-layout/searchbar/searchbar.component';
import {FormatAnschriftAdressPipe} from './pipes/format/format-anschrift-address.pipe';
import {AvbemerkungTableComponent} from './widgets/avbemerkung-table/avbemerkung-table.component';
import {BodenbedeckungTableComponent} from './widgets/bodenbedeckung-table/bodenbedeckung-table.component';
import {GrundbuchplaeneTableComponent} from './widgets/grunbuchplaene-table/grundbuchplaene-table.component';
import {FlaechenanteilTableComponent} from './widgets/flaechenanteil-table/flaechenanteil-table.component';
import {LagebezeichnungTableComponent} from './widgets/lagebezeichnung-table/lagebezeichnung-table.component';
import {OrderByPersonGbMasterPipe} from './pipes/order/order-by-gb-persongbmaster.pipe';
import {GrundstueckArtLangPipe} from './pipes/simple/grundstueck-art-lang.pipe';
import {
  FunctionbarSearchresultButtonsComponent
} from './components/title-functionbar/functionbar-searchresult-buttons/functionbar-searchresult-buttons.component';
import {RangregelungTableComponent} from './widgets/rangregelung-table/rangregelung-table.component';
import {UniqueErwerbsgrundPipe} from './pipes/simple/unique-erwerbsgrund.pipe';
import {AvbemerkungArtPipe} from './pipes/simple/avbemerkung-art.pipe';
import {CapFormColumnsDirective} from './form-control/form-columns.directive';
import {
  CapFormControlComponent,
  CapFormControlHelpDirective,
  CapFormControlLabelDirective,
  CapFormControlSubTemplateDirective,
  CapFormControlViewContainerDirective
} from './form-control/form-control.component';
import {CapFormRowDirective} from './form-control/cap-form-row.directive';
import {FormLayout, VerticalFormLayout} from './form-control/form-layout';
import {ValidationMessageService} from './form-control/validation-message.service';
import {CapRenderNextToDatePickerDirective, DatepickerComponent} from './datepicker/datepicker.component';
import {RegisterFormControlInputDirective} from './form-control/register-form-control-input.directive';
import {BedagDatepickerI18n} from './datepicker/datepicker-i18n';
import {BedagDateParserFormatter} from './datepicker/date-parser-formatter';
import {NgbDateParserFormatter, NgbDatepickerI18n} from '@ng-bootstrap/ng-bootstrap';
import {ColumnHeaderComponent} from './tablesort/sort-icon/column-header.component';
import {FremdsystemeComponent} from './components/fremdsysteme/fremdsysteme.component';
import {FremdsystemVisibilityFilterPipe} from './pipes/simple/fremdsystem-visibility-filter-pipe';
import {OrderBySdrGrundstueckNummerPipe} from './pipes/order/order-by-sdr-grundstueck-nummer.pipe';
import {GebaeudeGehoertZuSdrComponent} from './components/gebaeude-gehoert-zu-sdr/gebaeude-gehoert-zu-sdr.component';
import {InlineFormDirective} from './form-control/inline-form.directive';
import {MizenInboxComponent} from '../core/extension/mizen-inbox/mizen-inbox.component';
import {GebaeudeArtStringPipe} from './pipes/simple/gebaeude-art-string.pipe';
import {SearchStateService} from './services/search-state.service';
import {FunctionbarComponent} from './functionbar/functionbar/functionbar.component';
import {FunctionbarListComponent} from './functionbar/functionbar-list';
import {OptimisticLockModalComponent} from './components/modals/optimistic-lock-modal/optimistic-lock-modal.component';
import {AuszugIcpComponent} from './components/auszug-icp/auszug-icp.component';
import {GrundstueckFilterPipe} from './pipes/simple/grundstueck-filter.pipe';
import {CmisComponent} from './components/cmis/cmis.component';
import {CmisService} from './components/cmis/cmis.service';
import {CmisModalComponent} from "./components/cmis/cmisModal/cmis-modal.component";

@NgModule({
  imports: [
    CommonModule,
    CoreModule,
    FormsModule,
    ReactiveFormsModule,
    RouterModule,
    // Components
    CapFormColumnsDirective,
    CapFormControlComponent,
    CapFormControlViewContainerDirective,
    CapFormControlSubTemplateDirective,
    CapFormControlLabelDirective,
    CapFormControlHelpDirective,
    CapFormRowDirective,
    DatepickerComponent,
    FunctionbarComponent,
    FunctionbarListComponent,
    RegisterFormControlInputDirective,
    CapRenderNextToDatePickerDirective,
    InlineFormDirective,
    AlpgrundstueckeComponent,
    AuszugComponent,
    AuszugIcpComponent,
    AvMutationsNummerComponent,
    AvbemerkungTableComponent,
    BauortComponent,
    BelegComponent,
    BreadcrumbComponent,
    BodenbedeckungTableComponent,
    CapSpinnerSmallComponent,
    ColumnHeaderComponent,
    DokulinkComponent,
    DokulinkModalComponent,
    DominierteGrundstueckeComponent,
    EigentuemerAuszugSettingsComponent,
    GbAmtComponent,
    GbGemeindeComponent,
    GebaeudeComponent,
    GeogeschaeftTableComponent,
    GeometergeschaeftNummerComponent,
    GrundstueckAuszugSettingsComponent,
    GrundstueckBemerkungComponent,
    EigentumTableComponent,
    FlaechenanteilTableComponent,
    LagebezeichnungTableComponent,
    GrundbuchplaeneTableComponent,
    GrundpfandrechtTableComponent,
    GrundstueckflaecheComponent,
    GrundstueckTableComponent,
    GrundstueckNummerComponent,
    GrundstueckSelectionComponent,
    HaengigeAuftraegeComponent,
    HaengigeGbGeschaefteComponent,
    HaengigeGeoGeschaefteComponent,
    HaengigeGeschaefteAuftraegeComponent,
    HistorisiertComponent,
    HistoryOptionsComponent,
    KompaktAmtlicheBewertungComponent,
    KompaktAvMutationComponent,
    KompaktBelegComponent,
    KompaktGeometergeschaeftComponent,
    KompaktGrundbuchgeschaeftComponent,
    KompaktGrundpfandrechtBeschreibungComponent,
    KompaktGrundpfandrechtComponent,
    KompaktGrundstueckComponent,
    KompaktGrundstueckDetailComponent,
    KompaktNeskoabGrundstueckComponent,
    KompaktPersonenadresseComponent,
    KompaktPersongbComponent,
    KompaktPfandrechtBelastungComponent,
    KompaktStammpersonComponent,
    KompaktStandardRechtBeschreibungComponent,
    KompaktStandardrechtComponent,
    KompaktTimepointComponent,
    KompaktZusatzangabenComponent,
    KopfdatenelementComponent,
    KuhrechtComponent,
    LinkComponent,
    LogoComponent,
    MapsComponent,
    MizenInboxComponent,
    OrtschaftSelectionComponent,
    PolGemeindeComponent,
    ProjektstatusComponent,
    ReadMoreComponent,
    RechteAuszugSettingsComponent,
    RechteSelectionComponent,
    RechtListBeschreibungComponent,
    RechtsgrundComponent,
    RechtsgueltigHaengigComponent,
    RegionenComponent,
    RubrikComponent,
    SearchbarComponent,
    SonderrechtComponent,
    StammgrundstueckComponent,
    StandardrechtTableComponent,
    StichwortAblaufdatumComponent,
    ListLoaderWrapperComponent,
    TagebuchNummerComponent,
    TeilDatumComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    ContentHeaderComponent,
    DirtyCheckModalComponent,
    DeleteCheckModalComponent,
    ResetCheckModalComponent,
    OptimisticLockModalComponent,
    RangregelungTableComponent,
    FremdsystemeComponent,
    CmisComponent,
    CmisModalComponent,
    // Directives
    AsideToggleDirective,
    AutofocusDirective,
    EgridValidatorDirective,
    HistoryDirective,
    MetaDirective,
    MetaDisablerDirective,
    MetaValidatorDirective,
    NAV_DROPDOWN_DIRECTIVES,
    PermissionDirective,
    TagebuchValidatorDirective,
    // Pipes
    ArrayAbbreviatePipe,
    ArtKurzPipe,
    AuftragsNummerPipe,
    BelastungArtPipe,
    BetragPipe,
    DatumPipe,
    DatumZeitPipe,
    DayMonthYearDatePipe,
    DecimalHochkommaPipe,
    FormatAnschriftAdressPipe,
    FormatAhvPipe,
    FormatAvReferenzNummerPipe,
    FormatAvReferenzNummernPipe,
    FormatBeEdidPipe,
    FormatBelegPipe,
    FormatEdidPipe,
    FormatMapErrorPipe,
    FormatGebaeudeArtPipe,
    FormatGeometergeschaeftsnummerPipe,
    FormatGeschaeftsnummerPipe,
    FormatPersonstammAddressPipe,
    FormatRechteIdPipe,
    FormatTimepointPipe,
    FormatUidPipe,
    FunctionbarSearchresultButtonsComponent,
    GbPersonPipe,
    GlaeubigerRolleCodePipe,
    GrundstueckArtPipe,
    GrundstueckArtLangPipe,
    GrundstuecknummerPipe,
    KompaktAmtnummerPipe,
    KompaktBenutzerPipe,
    KompaktCapititelPipe,
    KompaktEigentumanteilPipe,
    KompaktGebaeudeeingangsadressePipe,
    KompaktGebaeudeMasterPipe,
    KompaktGebaeudePipe,
    KompaktGrundbuchgeschaeftPipe,
    KompaktGrundstueckbeschreibungPipe,
    KompaktGrundstueckDetailPipe,
    KompaktGrundstueckPipe,
    KompaktGwrGrundstueckPipe,
    KompaktHandelsangabenPipe,
    KompaktVersionGebaeudeeingangsadressePipe,
    NamenInhaberPfandrechtartPipe,
    NeskoabGrundstuecknummerPipe,
    OrderByAuftragPipe,
    OrderByEingangadressePipe,
    OrderByErstellzeitpunktPipe,
    OrderByGbGeschaeftPipe,
    OrderByGeoGeschaeftPipe,
    OrderByGlaeubigerSchuldnerMasterPipe,
    OrderByGrundstuecknrRechtIdPipe,
    OrderByGrundstuecknummerPipe,
    OrderByLastrechtEntryPipe,
    OrderByLastRechtGruppePipe,
    OrderByLastRechtPersonEntryVmPipe,
    OrderByLastRechtRootEntryVmPipe,
    OrderByNameVornamePipe,
    OrderByPfandrechtBelastungMasterPipe,
    OrderByPfandrechtBelastungPipe,
    OrderBySdrGrundstueckNummerPipe,
    OrderByRechteIdPipe,
    OrderByTranslatePipe,
    ProjektstatusComponent,
    SafeHtmlPipe,
    SafeUrlPipe,
    StammpersonTableComponent,
    SubstringPipe,
    BeschreibungTableWrapperComponent,
    TooltipPersonstammPipe,
    TranslateNamePipe,
    YesNoPipe,
    OrderByPersonGbMasterPipe,
    UniqueErwerbsgrundPipe,
    AvbemerkungArtPipe,
    FremdsystemVisibilityFilterPipe,
    GebaeudeGehoertZuSdrComponent,
    GebaeudeArtStringPipe,
    GrundstueckFilterPipe
  ],
  exports: [
    CapFormColumnsDirective,
    CapFormControlComponent,
    CapFormRowDirective,
    DatepickerComponent,
    FunctionbarComponent,
    FunctionbarListComponent,
    RegisterFormControlInputDirective,
    CapFormControlViewContainerDirective,
    InlineFormDirective,
    // Components
    AlpgrundstueckeComponent,
    AuszugComponent,
    AuszugIcpComponent,
    AvMutationsNummerComponent,
    AvbemerkungTableComponent,
    BauortComponent,
    BelegComponent,
    BreadcrumbComponent,
    BodenbedeckungTableComponent,
    CapSpinnerSmallComponent,
    ColumnHeaderComponent,
    DokulinkComponent,
    DokulinkModalComponent,
    DominierteGrundstueckeComponent,
    EigentuemerAuszugSettingsComponent,
    EigentumTableComponent,
    FlaechenanteilTableComponent,
    LagebezeichnungTableComponent,
    GbAmtComponent,
    GbGemeindeComponent,
    GebaeudeComponent,
    GeogeschaeftTableComponent,
    GeometergeschaeftNummerComponent,
    GrundbuchplaeneTableComponent,
    GrundpfandrechtTableComponent,
    GrundstueckAuszugSettingsComponent,
    GrundstueckBemerkungComponent,
    GrundstueckflaecheComponent,
    GrundstueckTableComponent,
    GrundstueckNummerComponent,
    GrundstueckSelectionComponent,
    HaengigeAuftraegeComponent,
    HaengigeGbGeschaefteComponent,
    HaengigeGeoGeschaefteComponent,
    HaengigeGeschaefteAuftraegeComponent,
    HistorisiertComponent,
    HistoryOptionsComponent,
    KompaktAmtlicheBewertungComponent,
    KompaktAvMutationComponent,
    KompaktBelegComponent,
    KompaktCapititelPipe,
    KompaktGeometergeschaeftComponent,
    KompaktGrundbuchgeschaeftComponent,
    KompaktGrundpfandrechtBeschreibungComponent,
    KompaktGrundpfandrechtComponent,
    KompaktGrundstueckComponent,
    KompaktGrundstueckDetailComponent,
    KompaktNeskoabGrundstueckComponent,
    KompaktPersonenadresseComponent,
    KompaktPersongbComponent,
    KompaktPfandrechtBelastungComponent,
    KompaktStammpersonComponent,
    KompaktStandardRechtBeschreibungComponent,
    KompaktStandardrechtComponent,
    KompaktTimepointComponent,
    KompaktZusatzangabenComponent,
    KopfdatenelementComponent,
    KuhrechtComponent,
    LinkComponent,
    LogoComponent,
    MapsComponent,
    MizenInboxComponent,
    OrtschaftSelectionComponent,
    PolGemeindeComponent,
    ProjektstatusComponent,
    RangregelungTableComponent,
    ReadMoreComponent,
    RechteAuszugSettingsComponent,
    RechteSelectionComponent,
    RechtListBeschreibungComponent,
    RechtsgrundComponent,
    RechtsgueltigHaengigComponent,
    RegionenComponent,
    RubrikComponent,
    SearchbarComponent,
    SonderrechtComponent,
    SonderrechtComponent,
    StammgrundstueckComponent,
    StammpersonTableComponent,
    StandardrechtTableComponent,
    StichwortAblaufdatumComponent,
    BeschreibungTableWrapperComponent,
    ListLoaderWrapperComponent,
    TagebuchNummerComponent,
    TeilDatumComponent,
    TitleComponent,
    TitleFunctionbarComponent,
    ContentHeaderComponent,
    FunctionbarSearchresultButtonsComponent,
    FremdsystemeComponent,
    CmisComponent,
    CmisModalComponent,
    // Directives
    AsideToggleDirective,
    AutofocusDirective,
    EgridValidatorDirective,
    HistoryDirective,
    MetaDirective,
    MetaDisablerDirective,
    MetaValidatorDirective,
    NAV_DROPDOWN_DIRECTIVES,
    PermissionDirective,
    TagebuchValidatorDirective,
    // Pipes
    ArrayAbbreviatePipe,
    AuftragsNummerPipe,
    BelastungArtPipe,
    BetragPipe,
    DatumPipe,
    DatumZeitPipe,
    DayMonthYearDatePipe,
    DecimalHochkommaPipe,
    FormatAnschriftAdressPipe,
    FormatAhvPipe,
    FormatAvReferenzNummerPipe,
    FormatAvReferenzNummernPipe,
    FormatBeEdidPipe,
    FormatBelegPipe,
    FormatEdidPipe,
    FormatGebaeudeArtPipe,
    FormatGeometergeschaeftsnummerPipe,
    FormatGeschaeftsnummerPipe,
    FormatMapErrorPipe,
    FormatPersonstammAddressPipe,
    FormatRechteIdPipe,
    FormatTimepointPipe,
    FormatUidPipe,
    GbPersonPipe,
    GlaeubigerRolleCodePipe,
    GrundstueckArtPipe,
    GrundstueckArtLangPipe,
    GrundstuecknummerPipe,
    KompaktAmtnummerPipe,
    KompaktBenutzerPipe,
    KompaktCapititelPipe,
    KompaktEigentumanteilPipe,
    KompaktGebaeudeeingangsadressePipe,
    KompaktGebaeudeMasterPipe,
    KompaktGebaeudePipe,
    KompaktGrundbuchgeschaeftPipe,
    KompaktGrundstueckbeschreibungPipe,
    KompaktGrundstueckDetailPipe,
    KompaktGrundstueckPipe,
    KompaktGwrGrundstueckPipe,
    KompaktHandelsangabenPipe,
    KompaktVersionGebaeudeeingangsadressePipe,
    NamenInhaberPfandrechtartPipe,
    NeskoabGrundstuecknummerPipe,
    OrderByEingangadressePipe,
    OrderByErstellzeitpunktPipe,
    OrderByGbGeschaeftPipe,
    OrderByGeoGeschaeftPipe,
    OrderByGlaeubigerSchuldnerMasterPipe,
    OrderByGrundstuecknrRechtIdPipe,
    OrderByGrundstuecknummerPipe,
    OrderByLastrechtEntryPipe,
    OrderByLastRechtGruppePipe,
    OrderByLastRechtPersonEntryVmPipe,
    OrderByLastRechtRootEntryVmPipe,
    OrderByNameVornamePipe,
    OrderByPfandrechtBelastungMasterPipe,
    OrderByPfandrechtBelastungPipe,
    OrderByRechteIdPipe,
    OrderBySdrGrundstueckNummerPipe,
    OrderByTranslatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    SubstringPipe,
    TooltipPersonstammPipe,
    TranslateNamePipe,
    YesNoPipe,
    UniqueErwerbsgrundPipe,
    AvbemerkungArtPipe,
    GebaeudeGehoertZuSdrComponent,
    GebaeudeArtStringPipe,
    GrundstueckFilterPipe
  ],
  providers: [
    {provide: FormLayout, useClass: VerticalFormLayout},
    ValidationMessageService,
    {provide: NgbDatepickerI18n, useClass: BedagDatepickerI18n},
    {provide: NgbDateParserFormatter, useClass: BedagDateParserFormatter},
    // Services and Pipes (Use Core for App-wide)
    ArrayAbbreviatePipe,
    BetragPipe,
    DatumPipe,
    DatumZeitPipe,
    DayMonthYearDatePipe,
    DecimalHochkommaPipe,
    DecimalPipe,
    FormatAnschriftAdressPipe,
    FormatAhvPipe,
    FormatAvReferenzNummerPipe,
    FormatAvReferenzNummernPipe,
    FormatBeEdidPipe,
    FormatBelegPipe,
    FormatEdidPipe,
    FormatGebaeudeArtPipe,
    FormatGeometergeschaeftsnummerPipe,
    FormatGeschaeftsnummerPipe,
    FormatMapErrorPipe,
    FormatPersonstammAddressPipe,
    FormatRechteIdPipe,
    FormatTimepointPipe,
    FormatUidPipe,
    GlaeubigerRolleCodePipe,
    GrundstueckArtPipe,
    GrundstueckArtLangPipe,
    GrundstuecknummerPipe,
    KompaktAmtnummerPipe,
    KompaktBenutzerPipe,
    KompaktCapititelPipe,
    KompaktEigentumanteilPipe,
    KompaktGebaeudeeingangsadressePipe,
    KompaktGebaeudeMasterPipe,
    KompaktGebaeudePipe,
    KompaktGrundbuchgeschaeftPipe,
    KompaktGrundstueckbeschreibungPipe,
    KompaktGrundstueckDetailPipe,
    KompaktGrundstueckPipe,
    KompaktGwrGrundstueckPipe,
    KompaktHandelsangabenPipe,
    KompaktVersionGebaeudeeingangsadressePipe,
    OrderByEingangadressePipe,
    OrderByErstellzeitpunktPipe,
    OrderByGbGeschaeftPipe,
    OrderByGeoGeschaeftPipe,
    OrderByGlaeubigerSchuldnerMasterPipe,
    OrderByGrundstuecknrRechtIdPipe,
    OrderByGrundstuecknummerPipe,
    OrderByLastrechtEntryPipe,
    OrderByLastRechtGruppePipe,
    OrderByLastRechtPersonEntryVmPipe,
    OrderByLastRechtRootEntryVmPipe,
    OrderByPfandrechtBelastungMasterPipe,
    OrderByPfandrechtBelastungPipe,
    OrderByRechteIdPipe,
    OrderByTranslatePipe,
    SafeHtmlPipe,
    SafeUrlPipe,
    TooltipPersonstammPipe,
    TranslateNamePipe,
    UniqueErwerbsgrundPipe,
    AvbemerkungArtPipe,
    GebaeudeArtStringPipe,
    GrundstueckFilterPipe,
    // Services (Use Core for App-wide)
    AuszugPrintService,
    AuszugSettingsService,
    ComparatorService,
    ComponentLocationStrategy,
    DokulinkItemBuilderFactory,
    MapServiceFactory,
    SearchStateService,
    CmisService
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SharedModule {
}
